import React, { FC, useEffect, useState } from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";

import { Form } from "react-final-form";
import { SelectField } from "../../lib/components/form/SelectField";
import { TextField } from "../../lib/components/form/TextField";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme: Theme) =>
  createStyles({
    formBody: {
      paddingTop: `${theme.spacing(2)}px`,
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      gap: `${theme.spacing(4)}px`,
    },
    formRow: {
      gap: `${theme.spacing(1)}px`,
    },
  });

type TemplatesMasterCrudProps = {
  onSubmit: any;
  onClose: () => void;
  formRecord: any;
  varietiesData: any;
  commoditiesData: any;
} & WithStyles<typeof styles>;

const TemplatesMasterCrudUnstyled: FC<TemplatesMasterCrudProps> = ({ onSubmit, onClose, formRecord, varietiesData, commoditiesData, classes }) => {
  const [varietiesFiltered, setVarietiesFiltered] = useState([]);

  const onClickCommodity = (value: string) => {
    setVarietiesFiltered(varietiesData.filter((v) => v.data.commodity_id == value));
  };

  useEffect(() => {
    if (formRecord.commodity_code) {
      onClickCommodity(formRecord.commodity_code);
    }
  }, [formRecord]);

  return (
    <>
      {commoditiesData && varietiesData && (
        <Dialog open={true} TransitionComponent={Transition} onClose={onClose} aria-labelledby="alert-slide-dialog-title" aria-describedby="alert-dialog-slide-description">
          <DialogTitle id="form-dialog-slide-title">{`Add New Template`}</DialogTitle>
          <DialogContent>
            <Form
              initialValues={{ ...formRecord }}
              onSubmit={onSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Grid className={classes.formBody}>
                    <div className={classes.formRow}>
                      <TextField field="templatename" title="Template Name" />
                      <SelectField field="commodity_code" title="Commodity Code" data={commoditiesData} onParse={(value) => onClickCommodity(value)} />
                      <SelectField field="variety_id" title="Variety" data={varietiesFiltered} />
                    </div>
                    <div style={{ float: "right" }}>
                      <Button type="submit" variant="contained" color="secondary" style={{ margin: "2px" }} onClick={() => onClose()}>
                        cancel
                      </Button>
                      <Button type="submit" variant="contained" color="primary" style={{ margin: "2px" }}>
                        accept
                      </Button>
                    </div>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default withStyles(styles)(TemplatesMasterCrudUnstyled);
